import { render, staticRenderFns } from "./DashboardClienteHanes.vue?vue&type=template&id=78bd63c2&scoped=true&"
import script from "./DashboardClienteHanes.vue?vue&type=script&lang=js&"
export * from "./DashboardClienteHanes.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClienteHanes.vue?vue&type=style&index=0&id=78bd63c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd63c2",
  null
  
)

export default component.exports